<section>
  @if(loadingState) {
    <app-bm-loading-state/>
  } @else {
    <div *ngIf="selectorData && budgetForm" class="flex flex-col gap-1.25">
      <app-header-budget-model
        class="main"
        [budgetForm]="budgetForm"
        [selectorData]="selectorData"
        (modelSelectedEmitter)="changeModel($event)"
        (buttonClickEmitter)="buttonClicked($event)">
      </app-header-budget-model>
      <app-table-budget-model class="main" [budgetForm]="budgetForm"/>
    </div>
  }
</section>


